module.exports = __webpack_public_path__ + "static/media/garbage-2.f9a9c7b8.svg";